import { service } from '@/utils/request'

export default {
    // 分页
	getDataList(params) {
	    return service({
            url: '/cloud/push/admin/pushWechatTemplate/pages',
            method: 'get',
            params: params
	    })
	},
    // 获取模板列表
	getWxTempLateList() {
	    return service({
            url: '/cloud/weixin/platform/getWxTempLateList',
            method: 'get'
	    })
	},
    save(data) {
		return service({
			url: '/cloud/push/admin/pushWechatTemplate/save',
			method: 'post',
            data
		})
	},
    getDetail(params) {
		return service({
			url: '/cloud/push/admin/pushWechatTemplate/detail',
			method: 'get',
            params
		})
	},
    remove(params) {
		return service({
			url: '/cloud/push/admin/pushWechatTemplate/delete',
			method: 'post',
            params
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/servicePush.js